import { Box, Text } from '@chakra-ui/react';
import { TimerOutlined } from '@mui/icons-material';
import { useEffect, useState } from 'react';

export function CountdownTimer({ endTime }: { endTime: number }) {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance < 0) {
        setTimeLeft('Expired');
        return;
      }

      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const formattedHours = String(hours).padStart(2, '0');
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(seconds).padStart(2, '0');

      setTimeLeft(`${formattedHours}:${formattedMinutes}:${formattedSeconds}`);
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [endTime]);

  return (
    <Box
      display="inline-flex"
      justifyContent="center"
      alignItems="center"
      gap="0.5"
      ms="0 !important"
    >
      <Box
        color="maroon"
        boxSize={{ base: '0.875rem', md: '1rem' }}
        display="flex"
        alignItems="center"
      >
        <TimerOutlined sx={{ width: '100%', height: '100%' }} />
      </Box>
      <Text
        color="maroon"
        fontSize={{ base: 'xs', md: 'md' }}
        fontWeight="bold"
        sx={{ fontVariantNumeric: 'tabular-nums' }}
        lineHeight="1"
      >
        {timeLeft}
      </Text>
    </Box>
  );
}
